<template>
  <div class="order-item" :data-state="order.orderStatus" @click="toDetail(order.orderNum)">
    <div class="order-item-hd">
      <div class="fl">{{ $t('orderNum') }} {{ order.orderNum }}</div>
      <div class="fr text-muted">{{ order.orderTime }}</div>
    </div>
    <div class="order-item-bd">
      <div class="tr clearfix">
        <div class="td fl">
          <div class="order-logo-wrap">
            <img class="order-logo img-responsive" :src="order.pic"/>
          </div>
        </div>
        <div class="td fl order-center">
          <div class="product-name bold">{{ order.productName }}</div>
          <div class="order-status">{{ order.orderStatusName }}</div>
        </div>
        <div class="td fr">
          <div class="product-price bold red">
            <template v-if="order.payOutPrice">
              <span class="common-price">{{ order.payOutPrice | fen2yuan }}</span>
            </template>
            <template v-else>
              <span class="common-price">{{(+order.orderPrice + (+order.pkgPriceAddition || 0)) | fen2yuan }}</span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  props: {
    order: {
      type: Object
    }
  },
  methods: {
    toDetail (orderId) {
      this.$emit('choosed', orderId);
    }
  }
};
</script>

<style scoped>
  @import 'config.css';

  .color-gray {
    color: #666;
  }
  .bold {
    font-weight: bold;
  }
  .red {
    color: #C23838;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .order-item {
    position: relative;
    margin-bottom: 15px;
    background: #fff;
    cursor: pointer;
    &[data-state="2"] {
      .order-status {
        color: #BF6D6D;
      }
    }
  }
  .order-item-hd {
    height: 63px;
    padding: 0 27px;
    padding-top: 23px;
    padding-bottom: 20px;
    line-height: 20px;
  }
  .order-item-bd {
    position: relative;
    padding: 0 27px;
    padding-top: 30px;
    padding-bottom: 20px;
    &::before {
      content: " ";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 1px;
      background: #E6E6E6;
    }
  }
  .order-logo-wrap {
    width: 104px;
  }
  .product-name {
    margin-top: 20px;
    font-size: 18px;
  }
  .order-status {
    margin-top: 4px;
    color: #A0A0A0;
  }
  .product-price {
    margin-top: 34px;
    font-size: 18px;
  }

  @media (--sm-viewport) {
    .order-center {
      width: 10em;
      max-width: 40%;
    }

    .order-item-hd, .order-item-bd {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
